import { ApiBase } from '../api.js';
import { listingsMock } from '../mocks/listings.js';
import { Listings } from '../types/api/listings.js';
import { SearchFilters, UpdateLitingProviderStatus, UpdateStatus } from '../types/custom.js';

export class ApiListings extends ApiBase {
	async scrape(data: Partial<{ includeMetadata: boolean; url: string[]; }>): Promise<Listings> {
		const result = await this.api.post('/scraping', data);
		return result.data;
	}

	async create(data: Partial<Listings>): Promise<Listings> {
		const result = await this.api.post('/listings', data);
		return result.data;
	}

	async importCsv(
		data: Partial<{ csv: string; csvType: string; brand_id: string; forbiddenWords: string; }>
	): Promise<any> {
		const result = await this.api.post('/listings/csv-import', data);
		return result.data;
	}

	async read(data: SearchFilters): Promise<typeof listingsMock> {
		const result = await this.api.post('/listings/get', data);
		return result.data;
	}

	async getOne(id: string): Promise<typeof listingsMock> {
		const result = await this.api.get(`/listings/get-single/${ id }`);
		return result.data;
	}

	async updateProviderListingsStatus(data: UpdateLitingProviderStatus): Promise<UpdateStatus> {
		const result = await this.api.post('/listings/update-provider-status', data);
		return result.data;
	}

	async updateListingsStatus(data: UpdateStatus): Promise<UpdateStatus> {
		const result = await this.api.post('/listings/update-status', data);
		return result.data;
	}

	async updateListing(id: string, data: FormData): Promise<Listings> {
		const result = await this.api.put(`/listings/update/${ id }`, data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}

	async delete(data: Partial<Listings>): Promise<Listings> {
		const result = await this.api.delete('/listings', data);
		return result.data;
	}

	async readTop(data: any): Promise<typeof listingsMock> {
		const result = await this.api.post('/listings/top', data);
		return result.data;
	}

	async updateStaus(data: any): Promise<typeof listingsMock> {
		const result = await this.api.post('/listings/update-provider-status', data);
		return result.data;
	}

	async export(data: SearchFilters): Promise<string> {
		const result = await this.api.post('/listings/export-listings', data, {
			responseType: 'blob'
		});
		return result.data;
	}

	async getMarkForReviewCount(licensorId: string): Promise<number> {
		const result = await this.api.get(`/listings/mark-for-review-count/${ licensorId }`);
		return result.data.totalCount;
	}

	async updateListingDataPoints(data: any) {
		const result = await this.api.put(`/listings/update-listing`, data);
		return result.data;
	}

	async updateMultipleListingsStatus(data: UpdateStatus): Promise<UpdateStatus> {
		const result = await this.api.post('/listings/update-multiple-statuses', data);
		return result.data;
	}

	async getListingIds(data: SearchFilters): Promise<string[]> {
		const result = await this.api.post('/listings/get-listing-ids', data);
		return result.data;
	}

	async bulkUpdateCategory(data: { listing_ids: string[]; category_id: string; }): Promise<any> {
		const result = await this.api.post('/listings/bulk-update-category', data);
		return result.data;
	}
}
